import { ArticleParagraph1, ArticleParagraph2, ArticleParagraph3, ArticleParagraph4 } from '../Article/ArticleParagraph';
/**
 * @deprecated используйте ArticleParagraph1 или UIText1
 */

export var Paragraph1 = ArticleParagraph1;
/**
 * @deprecated используйте ArticleParagraph2 или UIText2
 */

export var Paragraph2 = ArticleParagraph2;
/**
 * @deprecated используйте ArticleParagraph3 или UIText3
 */

export var Paragraph3 = ArticleParagraph3;
/**
 * @deprecated используйте Overline или кастомный CSS
 */

export var Paragraph4 = ArticleParagraph4;